const prodCredentials = {
  baseURL: 'https://checkout.tempestapps.io'
}

const testCredentials = {
  baseURL: 'https://uk-checkout-tempestapps-io-test.web.app'
}

export default process.env.NODE_ENV === 'production' ? prodCredentials : testCredentials
